<app-replenish-your-good-bacteria [slug]="UpsellSlugs.ShippedProbiotics">
  <p class="mb-4">
    Yeast medication, while effective in combating Yeast-causing bacteria, can unintentionally disrupt the delicate
    balance of beneficial bacteria in your gut. However, there's a powerful solution: taking extra-strength probiotics.
  </p>
  <p class="mb-4">
    By incorporating these daily for 30 days, both during and after your antibiotic course, you're not just restoring
    but nurturing the essential good bacteria your body craves. This is your key to not only recovering but thriving
    with renewed vitality and well-being.
  </p>
</app-replenish-your-good-bacteria>
